/**
 * @generated SignedSource<<5eda3a014463d129f0297c6cf0f9bbcd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeletePersonEmailInput = {
  personId: number;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type deletePersonEmailMutation$variables = {
  input: DeletePersonEmailInput;
};
export type deletePersonEmailMutation$data = {
  readonly DeletePersonEmail: {
    readonly MissionControlPersonList: {
      readonly id: string;
      readonly personId: number | null;
      readonly companyId: number | null;
      readonly companyName: string | null;
      readonly accountPlan: string | null;
      readonly firstName: string | null;
      readonly lastName: string | null;
      readonly email: string | null;
      readonly active: boolean | null;
    } | null;
  } | null;
};
export type deletePersonEmailMutation = {
  variables: deletePersonEmailMutation$variables;
  response: deletePersonEmailMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeletePersonEmailPayload",
    "kind": "LinkedField",
    "name": "DeletePersonEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MissionControlPersonListType",
        "kind": "LinkedField",
        "name": "MissionControlPersonList",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "personId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "companyName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountPlan",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "active",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "deletePersonEmailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "deletePersonEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "f274e8ce15fd25200b883b0d3c3ce738",
    "id": null,
    "metadata": {},
    "name": "deletePersonEmailMutation",
    "operationKind": "mutation",
    "text": "mutation deletePersonEmailMutation(\n  $input: DeletePersonEmailInput!\n) {\n  DeletePersonEmail(input: $input) {\n    MissionControlPersonList {\n      id\n      personId\n      companyId\n      companyName\n      accountPlan\n      firstName\n      lastName\n      email\n      active\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f931512391b09e6704985747c7fdb0b1";

export default node;
